import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Bank
 */
@Entity()
export class Bank extends Partner {
  static override _class = 'Bank';

  override get type() {
    return KooperationsPartner.BANK;
  }
}
